/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiDevice } from './Device';

export interface PostUsersAuthRequest {

    method?: string;

    email?: string;

    password?: string;

    rememberMe?: boolean;

    device?: ApiDevice;

    iap_receipt?: string;

    iap_refresh?: boolean;

    iap_type?: string;

    play_token?: string;

    product_id?: string;

    roku_transaction_id?: string;

    purchased?: boolean;

    app?: string;

    flow?: string;

}

@Model('PostUsersAuth')
export class ApiPostUsersAuth extends BaseModel implements PostUsersAuthRequest {

    
    
    method: string;

    
    
    email: string;

    
    
    password: string;

    
    
    rememberMe: boolean;

    @Type('ApiDevice')
    @Expand()
    device: ApiDevice;

    
    
    iap_receipt: string;

    
    
    iap_refresh: boolean;

    
    
    iap_type: string;

    
    
    play_token: string;

    
    
    product_id: string;

    
    
    roku_transaction_id: string;

    
    
    purchased: boolean;

    
    
    app: string;

    
    
    flow: string;

}
